import React from 'react'

export default function Interests() {
    return (
        <div className="section">
            <h2 className="section--heading">Interests</h2>
            <p className="section--content">Coding. Sewing. Learning</p>
        </div>
    )
}